import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 8.4 4.93"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M8.18.21a.76.76 0 0 0-1.05 0L4.2 3.14 1.27.21a.76.76 0 0 0-1.05 0 .726.726 0 0 0 0 1.04l3.46 3.46c.14.14.33.22.52.22s.38-.08.52-.22l3.46-3.46c.14-.14.22-.33.22-.53S8.32.34 8.18.2Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }